// Quiz Creator Route Wrapper - Handles URL parameters
import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import QuizCreator from "./quiz/QuizCreator";

const QuizCreatorRoute: React.FC = () => {
  const { quizId } = useParams<{ quizId: string }>();
  const [searchParams] = useSearchParams();
  const courseId = searchParams.get("courseId") || "";

  // Pass both courseId and quizId to QuizCreator for editing mode
  return <QuizCreator courseId={courseId} quizId={quizId} />;
};

export default QuizCreatorRoute;
